import React from 'react';
import PropTypes from 'prop-types';

function ChevronActive({ size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.66675 10L8.00008 4.66667L13.3334 10" stroke="#88898B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

ChevronActive.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
}

export default ChevronActive;
